var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bind as Bind } from 'bind-decorator';
import { normalizePath } from './node';
var PathData = (function () {
    function PathData(singleNode, summaryNodes, childPaths) {
        this.singleNode = singleNode;
        this.summaryNodes = summaryNodes;
        this.childPaths = childPaths;
    }
    return PathData;
}());
export { PathData };
var PathDataCache = (function () {
    function PathDataCache() {
        this.cache = new Map();
    }
    PathDataCache.prototype.hasPathData = function (path) {
        path = normalizePath(path);
        return this.cache.has(path);
    };
    PathDataCache.prototype.isSingleNodeDataLoaded = function (path) {
        return this.hasPathData(path) && !!this.getPathData(path).singleNode;
    };
    PathDataCache.prototype.isChildrenDataLoaded = function (path) {
        return this.hasPathData(path) && !!this.getPathData(path).childPaths;
    };
    PathDataCache.prototype.isSummaryNodeDataLoaded = function (path) {
        return this.hasPathData(path) && !!this.getPathData(path).summaryNodes;
    };
    PathDataCache.prototype.getPathData = function (path) {
        path = normalizePath(path);
        if (!this.hasPathData(path)) {
            this.cache.set(path, new PathData());
        }
        return this.cache.get(path);
    };
    PathDataCache.prototype.addChildData = function (path, endpointData) {
        var _this = this;
        var parentData = this.getPathData(path);
        if (!parentData.childPaths) {
            parentData.childPaths = endpointData.singleNodes.map(function (node) { return node.path; });
        }
        endpointData.singleNodes.forEach(function (node) {
            var data = _this.getPathData(node.path);
            if (!data.singleNode) {
                data.singleNode = node;
            }
        });
        endpointData.summaryNodes.filter(function (node) { return !_this.isSummaryNodeDataLoaded(node.path); }).forEach(function (node) {
            var data = _this.getPathData(node.path);
            if (!data.summaryNodes) {
                data.summaryNodes = [];
            }
            if (!data.summaryNodes.some(function (snode) { return snode.path !== node.path; })) {
                data.summaryNodes.push(node);
            }
        });
    };
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Boolean)
    ], PathDataCache.prototype, "hasPathData", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Boolean)
    ], PathDataCache.prototype, "isSingleNodeDataLoaded", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Boolean)
    ], PathDataCache.prototype, "isChildrenDataLoaded", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Boolean)
    ], PathDataCache.prototype, "isSummaryNodeDataLoaded", null);
    __decorate([
        Bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", PathData)
    ], PathDataCache.prototype, "getPathData", null);
    return PathDataCache;
}());
export { PathDataCache };



// WEBPACK FOOTER //
// ./src/app/hsd-tree/shared/path-data-cache.ts.pre-build-optimizer.js